import React,{useState, useEffect} from 'react'
import './vidbackground.css'

function videobackground(props) {
 return (
     <div>

<div style={{
  width: '100%',
  height: props.height ? props.height : '100vh',
  overflow: 'hidden',
  backgroundColor: 'white'
}}>

<div className='videoWording'>{props.title}</div>

  <video
  autoPlay={true}
  muted={true}
  loop={true}
    style={{
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    }}
    src={props.src}
    //https://s3.amazonaws.com/akamai.netstorage/HD_downloads/Orion_SM.mp4
    // src="https://httest.s3.amazonaws.com/111_aXphX21fZXMyXzE4Ng_Trim+(1).mp4"
  />
</div>
</div>
)
}
export default videobackground


// WEBPACK FOOTER //
// ./src/components/VideoBackground/videobackground.jsx